<mat-form-field customColor="light" appearance="outline" [class.has-value]="hasValue">
  @if (label) {
    <mat-label>{{ label }}</mat-label>
  }
  <input matInput [formControl]="control" [name]="name" [placeholder]="placeholder" [autocomplete]="autocomplete"
    [type]="type" [min]="min" [max]="max" [step]="step">

  @if (suffixText) {
    <span matTextSuffix class="suffix-text">{{ suffixText }}</span>
  }

  @if (suffixIcon) {
    <div class="suffix-icon-container">
      <app-enfaf-icon [svgIconName]="suffixIcon" [iconSize]="iconSize || '21px'" class="suffix-icon"></app-enfaf-icon>
    </div>
  }

  @if (iconSuffix) {
    <button mat-icon-button matSuffix (click)="iconSuffix.click()" type="button" class="custom-icon-suffix">
      <mat-icon [svgIcon]="iconSuffix.icon"></mat-icon>
    </button>
  }

  @if (control?.invalid && control?.errors && !hasOtherErrors) {
    <mat-error>{{ errorLabel }}</mat-error>
  }
  @if (control.hasError('invalidAge')) {
    <mat-error>Debes ser mayor de 14 años para registrarte</mat-error>
  }
  @if (description && description.length > 0) {
    <mat-hint>{{description}}</mat-hint>
  }
</mat-form-field>